export default __webpack_public_path__ + "static/media/LandingPageTwo.7c584649.png";